gsap.registerPlugin(ScrollTrigger);

gsap.to('.vinyl-rotate', {
  scrollTrigger: {
    trigger: '.custom-album-animate',
    start: 'top 80%',
    end: 'bottom 45%',
    // markers: true,
    scrub: true,
    toggleActions: 'play pause resume reset',
  },
  rotation: 360,
  x: 0,
  duration: 3,
});

// console.log('scripts running');
